import { useContext } from 'react';

import { PortalConfigContext } from 'src/context';

/** True when the current workspace was created through the Studio onboarding flow. */
export function useIsStudioWorkspace(): boolean {
  const { isStudioUser } = useContext(PortalConfigContext);
  return isStudioUser === true;
}
